// All FeatureEEnum / EntitlementEEnum values from bw-sdk-bw-party (generated
// model). Granted to the demo user so the whole app is reachable — regenerate
// from the SDK after a production sync instead of editing by hand.
export const ALL_FEATURES = [
  "viewDashboard",
  "viewTransactions",
  "viewContacts",
  "productOverview",
  "productApplication",
  "financingProductApplication",
  "productCancellation",
  "contractedProducts",
  "transactionManagement",
  "bankAccountAdmin",
  "bankAccountView",
  "cashflowView",
  "budgets",
  "healthIndicator",
  "bankAccounts",
  "viewCompanyProfile",
  "editCompany",
  "viewTeam",
  "inviteUser",
  "manageUser",
  "createClientCompany",
  "createNewUserParty",
  "manageUserPreferences",
  "loggedInUser",
  "registeredUser",
  "analyticsView",
  "invoiceBasicOperations",
  "invoiceTakeOwnership",
  "invoiceEdit",
  "invoiceSubmitForApproval",
  "invoiceDelete",
  "invoiceExportToERP",
  "invoiceViewAll",
  "invoiceReview",
  "invoiceViewApprovalChain",
  "invoiceChangeApprovalPriority",
  "invoiceAddAdditionalApprover",
  "invoiceDelegateApprovals",
  "invoiceManageSuppliers",
  "invoiceManageCostCenters",
  "invoiceManageDocumentSeries",
  "invoiceManageContracts",
  "invoiceManageActivities",
  "invoiceManageCurrencies",
  "invoiceManageVatRates",
  "invoiceManagePaymentMethods",
  "invoiceLinesToggle",
  "invoiceConfigureERPConnectors",
  "invoiceConfigureEmailInbox",
  "invoiceConfigureTaskManager",
  "catalogBrowse",
  "catalogManagement",
  "approverDefinitionBrowse",
  "approverDefinitionManage",
  "approverProcessBrowse",
  "approverDecision",
  "productActivation",
] as const;

export const ALL_ENTITLEMENTS = [
  "viewDashboardPage",
  "viewBalanceChartMainDashboard",
  "viewBalanceChartCompanyDashboard",
  "viewBalanceChartAccountDetail",
  "viewTransactionsPage",
  "viewContactsPage",
  "viewProductOverviewDashboard",
  "viewMarketplaceContractSections",
  "viewContractValidationRules",
  "activateBibbyFactoringProduct",
  "activateRogerFactoringProduct",
  "activateBusinessInsuranceProduct",
  "activateFlowpayProduct",
  "activateMalcomFactoringProduct",
  "activateFinancingProduct",
  "cancelProduct",
  "viewMyProducts",
  "viewAvailableProducts",
  "viewBusinessInsuranceContract",
  "viewFlowpayFinancingContract",
  "viewTransactionList",
  "viewTransactionDetailOverview",
  "viewLabel",
  "changeTransactionCategory",
  "searchFilteringSortingOfTransactions",
  "addLabel",
  "removeLabel",
  "export",
  "deleteConnectedAccount",
  "editNameConnectedAccount",
  "connectAccount",
  "reconnectAccount",
  "editNotConnectedAccountName",
  "viewAccountActualBalance",
  "viewConnectedAccounts",
  "viewConnectedAccountDetailPage",
  "changeAccountCategoryPastFutureTransactions",
  "viewListOfAccounts",
  "viewAccountDetail",
  "changeAccountCategory",
  "viewAccountBalanceHistory",
  "viewAccountLastUpdateBadge",
  "viewCompanyActualBalance",
  "viewCompanyBalanceHistory",
  "viewAnalyticsDashboard",
  "selectCashflowChartType",
  "setCategoryFilter",
  "setTimePeriodFilter",
  "viewCategoryDetail",
  "viewTransactionDetail",
  "setCurrency",
  "viewCustomize",
  "saveCustomize",
  "viewCashflowWizard",
  "addManualTransaction",
  "editManualTransaction",
  "ignoreManualTransaction",
  "removeManualTransaction",
  "ignorePredictedTransaction",
  "setHealthIndicator",
  "setAccountsToCashflow",
  "viewCompanyProfile",
  "changeCompanyCurrency",
  "editCompanyName",
  "companyTermination",
  "changeTransactionCategorizationSettings",
  "viewList",
  "viewUserDetails",
  "invite",
  "resendInvite",
  "revokeInvite",
  "changeUserRole",
  "remove",
  "viewMyProfile",
  "changePassword",
  "changeLanguage",
  "changeCurrency",
  "editMKTConsents",
  "viewMyRoles",
  "viewOwnApprovalProcesses",
  "mergeDuplicateUser",
  "acceptInvite",
  "createClientCompany",
  "authenticateCaller",
  "publishBusinessEventAsUser",
  "viewAnalyticsPage",
  "manageBankAccount",
  "selectBankAccount",
  "viewOrModifyBankAccount",
  "viewOrModifyTransaction",
  "uploadInvoice",
  "createInvoiceManually",
  "viewOwnInvoice",
  "viewInvoiceAttachments",
  "downloadInvoiceAttachments",
  "createInvoiceNote",
  "editInvoiceNote",
  "deleteInvoiceNote",
  "viewInvoiceNotes",
  "viewInvoiceStatus",
  "viewInvoiceActivityLog",
  "archiveInvoice",
  "viewOwnInvoiceQueue",
  "deleteOwnUnassignedInvoice",
  "enterOwnInvoiceDetailsManually",
  "assignInvoiceToSelf",
  "unassignInvoice",
  "editInvoice",
  "editInvoiceLines",
  "overrideInvoiceInitialWarnings",
  "submitInvoiceForApproval",
  "deleteInvoice",
  "exportInvoiceToERP",
  "viewAllInvoices",
  "reviewInvoice",
  "viewInvoiceApprovalChain",
  "changeInvoicePriority",
  "addInvoiceApprover",
  "delegateInvoiceApprovals",
  "viewInvoiceSuppliers",
  "editInvoiceSuppliers",
  "viewInvoiceCostCenters",
  "editInvoiceCostCenters",
  "viewInvoiceDocumentSeries",
  "editInvoiceDocumentSeries",
  "viewInvoiceContracts",
  "editInvoiceContracts",
  "viewInvoiceActivities",
  "editInvoiceActivities",
  "viewInvoiceCurrencies",
  "editInvoiceCurrencies",
  "viewInvoiceVatRates",
  "editInvoiceVatRates",
  "viewInvoicePaymentMethods",
  "editInvoicePaymentMethods",
  "toggleInvoiceLines",
  "viewInvoiceERP",
  "editInvoiceERP",
  "viewInvoiceEmailInbox",
  "editInvoiceEmailInbox",
  "viewInvoiceTaskManager",
  "editInvoiceTaskManager",
  "getSessionTransferUrl",
  "viewAccountingAttribute",
  "manageAccountingAttribute",
  "viewApproverDefinitions",
  "searchApproverDefinitions",
  "filterApproverDefinitions",
  "viewApproverDefinitionDetail",
  "createApproverDefinition",
  "editApproverDefinition",
  "cloneApproverDefinition",
  "submitApproverDefinition",
  "cancelApproverDefinition",
  "viewApproverProcesses",
  "searchFilterApproverProcesses",
  "viewApproverProcessDetail",
  "viewOwnApproverProcesses",
  "searchFilterOwnApproverProcesses",
  "viewOwnApproverProcessDetail",
  "approveApproverItem",
  "rejectApproverItem",
  "returnApproverItem",
  "addApproverToOwnLevel",
  "changePriorityModeOnOwnProcess",
  "cancelOwnApprovalProcess",
  "resubmitOwnApprovalSubject",
  "viewCurrentApprovalDefinition",
  "activateProduct",
] as const;

export const ALL_FEATURE_ENTITLEMENTS = ALL_FEATURES.map((featureId) => ({
  featureId,
  entitlements: ALL_ENTITLEMENTS.map((entitlementId) => ({ entitlementId })),
}));
